import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { Button, Result } from "antd";

export const NotFoundPage = () => {
  return (
    <Result
      status={"404"}
      title={
        <FormattedMessage
          id="error.not_found.title"
          defaultMessage="Error 404"
        />
      }
      subTitle={
        <FormattedMessage
          id="error.not_found.sub_title"
          defaultMessage="Sorry, the page you visited does not exist."
        />
      }
      extra={
        <Button type="primary">
          <Link to={"/"}>
            <FormattedMessage
              id="error.back_to_home"
              defaultMessage="Back to Home"
            />
          </Link>
        </Button>
      }
    />
  );
};
